// API Configuration
export const API_CONFIG = {
  baseUrl: `${import.meta.env.VITE_URL}/api/v1/web`,
  timeout: 30000,
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    renewAccess: '/auth/renew-access',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },

  // Users
  users: {
    list: '/users',
    detail: (id: number | string) => `/users/${id}`,
    me: '/users/me',
  },

  // Clients
  clients: {
    list: '/clients',
    detail: (id: number | string) => `/clients/${id}`,
  },

  // Matters
  matters: {
    list: '/matters',
    detail: (id: number | string) => `/matters/${id}`,
  },

  // Contracts
  contracts: {
    list: '/contracts',
    detail: (id: number | string) => `/contracts/${id}`,
  },

  // Invoices
  invoices: {
    list: '/invoices',
    detail: (id: number | string) => `/invoices/${id}`,
  },

  // Time entries
  timeEntries: {
    list: '/time-entries',
    detail: (id: number | string) => `/time-entries/${id}`,
  },

  // Expenses
  expenses: {
    list: '/expenses',
    detail: (id: number | string) => `/expenses/${id}`,
  },

  // Calendar / Events
  events: {
    list: '/events',
    detail: (id: number | string) => `/events/${id}`,
  },

  // Reports
  reports: {
    dashboard: '/reports/dashboard',
    revenue: '/reports/revenue',
    matters: '/reports/matters',
  },

  // Settings
  settings: {
    company: '/settings/company',
    billing: '/settings/billing',
    practiceAreas: '/settings/practice-areas',
  },

  // Hourly Packages
  hourlyPackages: {
    list: '/hourly-packages',
    detail: (id: number | string) => `/hourly-packages/${id}`,
  },

  // Success Packages
  successPackages: {
    list: '/success-packages',
    detail: (id: number | string) => `/success-packages/${id}`,
  },
} as const;
